// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"09ee69e6","453":"5d897ab4","732":"2769c214"}[chunkId] + ".chunk.js";
};